import { snakeCase } from 'lodash';
import { mapChatStarterKindToUIFilterKind } from '../helpers/chat-starters-helpers';
// import { pathBuilder } from '../../editor/features/beta/modules/ChatStarters/pathBuilder';
import Actions from '../actions/actions';
import {
  ChatStartersCRUDActions,
  chatStartersCRUDActions,
  DeleteSuccessActionType,
  RetrievedAllSuccessActionType,
} from '../actions/ChatStartersCRUDActinos';
import {
  ChatStarterKindSnakeType,
  ChatStartersPayload,
  ChatStarterType,
  UIFilterStarterKindType,
} from '../model/ChatStarterModel';
import { setBusy, setUnBusy } from './common/commonReducers';

export type UIChatStarterType = ChatStarterType & {
  filterKind: UIFilterStarterKindType;
  // path: string;
};

type StarterRecords = Partial<
  Record<
    UIFilterStarterKindType,
    ChatStartersPayload & {
      chatStarters: UIChatStarterType[];
    }
  >
>;

type CountersType = Partial<Record<UIFilterStarterKindType, number>>;

export type ChatStartersStateType = {
  records: StarterRecords;
  invalidRecords: Partial<Record<UIFilterStarterKindType, boolean>>;
  activeFilterKind?: UIFilterStarterKindType;
  counters?: CountersType;
  busy: boolean;
};

const initial = {
  records: {},
  invalidRecords: {},
  activeFilterKind: undefined,
  counters: undefined,
  busy: false,
};

export const chatStarters = (
  state: ChatStartersStateType = initial,
  action: any,
) => {
  switch (action.type) {
    case ChatStartersCRUDActions.retrieveAllSuccess: {
      const retrievedAction: RetrievedAllSuccessActionType = action;

      const { botId, kind: queryKind, payload } = retrievedAction;

      const uiFilterKind = mapChatStarterKindToUIFilterKind(queryKind);

      const uiStarters: UIChatStarterType[] = payload.chatStarters.map(
        starter => ({
          ...starter,
          filterKind: mapChatStarterKindToUIFilterKind(starter.kind),
          // path: pathBuilder.buildResourceUrl(botId, starter),
        }),
      );

      const counters = payload.pagination.grouped || {};
      const entries = Object.entries(counters);

      let mappedCounters: CountersType = {};

      mappedCounters = entries.reduce((a, [key, value]) => {
        const kind = mapChatStarterKindToUIFilterKind(
          snakeCase(key) as ChatStarterKindSnakeType,
        );
        const cacheCount = a[kind] || 0;
        // aggregated counts
        if (value) a[kind] = cacheCount + Number(value);
        return a;
      }, mappedCounters);

      return {
        ...state,
        counters: {
          ...state.counters,
          ...mappedCounters,
          [uiFilterKind]: payload.pagination.total,
        },
        records: {
          ...state.records,
          [uiFilterKind]: {
            chatStarters: uiStarters,
            pagination: payload.pagination,
          },
        },
        invalidRecords: {
          ...state.invalidRecords,
          [uiFilterKind]: false,
        },
        busy: false,
      };
    }
    case ChatStartersCRUDActions.deleteSuccess: {
      const deleteAction: DeleteSuccessActionType = action;
      const {
        payload: { kind },
      } = deleteAction;
      const uiFilterKind = mapChatStarterKindToUIFilterKind(kind);

      return {
        ...state,
        invalidRecords: {
          ...state.invalidRecords,
          [uiFilterKind]: true,
        },
      };
    }
    case Actions.RESET:
    case ChatStartersCRUDActions.invalidateAll: {
      return initial;
    }
    case chatStartersCRUDActions.busyAction:
      return setBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
